import { UserT } from 'business/definitions';
import { QueryObserverResult, useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';

/**
 * Fetches users data. The result may be different depending on the user's role.
 * @returns  The result of the query containing the users data.
 */
export const useFetchUsers = (): QueryObserverResult<UserT[], unknown> =>
    useQuery({
        queryKey: ['users'],

        queryFn: async () => {
            const response = await RQAPICallWithData<UserT[]>({
                endpoint: 'auth/users',
                method: 'GET',
            });
            return response.content.data;
        },
    });
